import { loadAfterpayLib, loadAfterPayPaymentScript, setupBillingAgreementApproval } from '@services/vueAfterpaySvc';
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import { getObjProperty } from '@utilities/mrVueUtils';

export default {

  computed: {
    ...mapState('cart', ['cart']),

    ...mapState('customer', ['cdata']),

    ...mapGetters('payments', ['getPaymentProfileById']),

    ...mapState('payments', ['selectedProfileId']),

    ...mapState('payments', [
      'selectedProfileId',
    ]),

    ...mapState('systemSettings', [
      'thirdPartyPaymentsSystemSettings'
    ]),

    mix_afterpayFeatureActive() {
      return this.thirdPartyPaymentsSystemSettings.afterpayActive;
    },

    mix_isAfterpayPaymentCart() {
      return this.selectedProfileId && (this.getPaymentProfileById(this.selectedProfileId) || {}).paymentGateway === 'afterpay';
    },

    mix_afterPayAvailable() {
      return Boolean(this.mix_afterpayFeatureActive && getObjProperty(this, 'cart.afterpayEligible') && !getObjProperty(this, 'cart.locationId'));
    },
  },

  methods: {
    ...mapActions('systemSettings', [
      'initThirdPartyPaymentsSystemSettings'
    ]),

    ...mapMutations('payments', [
      'setAfterPayCheckoutToken',
    ]),

    mix_loadAfterPayScript() {
      loadAfterpayLib();
    },

    mix_loadAfterPayPaymentScript() {
      loadAfterPayPaymentScript();
    },

    async mix_setupBillingAgreementApproval() {
      const { phone, firstName, lastName, email } = this.cdata;

      const { data } = await setupBillingAgreementApproval({
        confirmUrl: `${window.location.origin}/confirm`,
        cancelUrl: `${window.location.origin}/cancel`,
        customer: {
          phone,
          firstName,
          lastName,
          email,
        },
      });

      const { token } = data;
      //- set the token in store so we can use it on order review page
      this.setAfterPayCheckoutToken(token);
    },
  },

  mounted() {
    this.initThirdPartyPaymentsSystemSettings();
  }
};